import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import ApiService from 'redux/services/api-service';
import {addResultCases} from 'utils/helpers';
import {LLMRequest, SingleResult} from 'utils/types';

export interface LLMRequestState {
  /** Keyed by LLMRequest id */
  request: SingleResult<LLMRequest>;
}

const initialState: LLMRequestState = {
  request: {as: 'idle'},
};

export const llmRequestEndpoints = {
  getLLMRequest: createAsyncThunk('llmRequest/getLLMRequest', async (id: number) => {
    const response = await ApiService.get(`/llm_request/${id}/`);
    return response.data as LLMRequest;
  }),
};

export const llmRequestSlice = createSlice({
  name: 'llmRequest',
  initialState,
  reducers: {},
  extraReducers: builder => {
    addResultCases(builder, llmRequestEndpoints.getLLMRequest, 'request');
  },
});

export type LLMRequestSlice = {
  [llmRequestSlice.name]: ReturnType<(typeof llmRequestSlice)['reducer']>;
};
